import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Row, Button, ButtonToolbar, Modal, ModalHeader, Card, CardBody } from 'reactstrap';
import { addActivity } from '../redux/actions/complianceActions'
import { connect } from 'react-redux';
import { withApollo, Mutation } from 'react-apollo';
import { GetComments, SaveComment } from '../queries/controls'
import ProfileActivities from './compliance/components/ComplianceLog'
import { Field } from 'redux-form';
import { signout } from '../redux/actions/userActions';
import { withRouter } from 'react-router-dom';

class ModalComponent extends PureComponent {
    static propTypes = {
        title: PropTypes.string,
        message: PropTypes.object,
        color: PropTypes.string.isRequired,
        colored: PropTypes.bool,
        header: PropTypes.bool
    };

    constructor(props) {
        super(props);
        this.toggle = this.props.toggle;
        this._isMounted = false;
    }

    componentWillUnmount () {
        this._isMounted = false;
    }
    state = {
        notes: []
    }

    addNewNote (note, saveToDB) {
        const notes = this.state.notes.map(note => note)
        const { user } = this.props

        notes.push({
            createdBy: `${user.given_name} ${user.family_name}`,
            createdAt: note.lastUpdated,
            comment: note.note
        })

        this.setState({ notes: notes })

        saveToDB({
            variables: {
                commentData: {
                    "framework": this.props.framework,
                    "highLevelCategory": this.props.highLevelCategory,
                    "lowLevelCategory": this.props.lowLevelCategory,
                    "controlID": this.props.id,
                    "comment": note.note,
                    "createdBy": `${this.props.user.given_name} ${this.props.user.family_name}`,
                    "createdAt": note.lastUpdated
                }
            }
        })
    }

    modalBody () {
        return (
            <div>
                <Card className='commentsCard'>
                    <CardBody className='profileActivities'>
                        <div className='test2'>
                            <ProfileActivities id={this.props.id} notes={this.state.notes} />
                        </div>
                    </CardBody>
                </Card>

                <div className='form__form-group-field' style={{ width: '100%' }}>
                    <Field
                        style={{ marginLeft: '4.5%' }}
                        name='textarea'
                        component='textarea'
                        type='text'
                        placeholder="Write a comment..."
                        className='modalTextArea'
                        id='modalComment'
                        value={this.state.comment}
                        onChange={(e) => {
                            this.setState({
                                comment: e.target.value
                            })
                        }}
                    />
                </div>
            </div >
        )
    }

    signoutUser () {
        this.props.signout();
        this.props.history.push('/');
    }

    async componentDidMount () {
        try {
            this._isMounted = true
            const { data: commentData } = await this.props.client.query({
                query: GetComments(this.props.framework,
                    this.props.lowLevelCategory,
                    this.props.highLevelCategory,
                    this.props.id),
                fetchPolicy: 'network-only',
                context: { tenantID: this.props.user["custom:tenant"] || null }
            })

            if (commentData && this._isMounted) {
                if (commentData && commentData.getComments) {
                    this.setState({
                        notes: commentData.getComments
                    });

                }
            }
        } catch (e) {
            if (e.networkError) {
                if (e.networkError['statusCode'] === 401) {
                    this.signoutUser()
                }
            } else {
                console.log(e.message)
                this.signoutUser()
            }
        }
    }

    render () {
        return (
            <div>
                {this.props.children}
                <Mutation
                    mutation={SaveComment()}
                    context={{ tenantID: this.props.user["custom:tenant"] }}
                    onCompleted={(data) => {
                    }}
                    onError={(e) => {
                        console.log(e)
                    }}
                >
                    {(saveComment, { loading, data: noteData, error: noteError }) => {
                        return (<Modal style={{
                            maxHeight: 400
                        }} isOpen={this.props.modal} //toggle={this.toggle}
                            className={`comments-modal modal-dialog--${this.props.color} ${this.props.colored ?
                                'modal-dialog--colored' : ''} ${this.props.header ? 'modal-dialog--header' : ''}`}>
                            <ModalHeader>
                                {this.props.title}
                                <span className='lnr lnr-cross modal__close-btn' onClick={this.toggle} />
                            </ModalHeader>
                            <div className='modal__body'>
                                {this.modalBody()}
                            </div>
                            <ButtonToolbar className='modal__footer'>
                                <Row >
                                    <Button id='commentSaveBtn'
                                        outline={this.props.colored}
                                        color={this.props.color}
                                        onClick={() => {
                                            if (document.getElementById('modalComment').value.trim().length > 0) {
                                                this.addNewNote({
                                                    id: this.props.id,
                                                    note: document.getElementById('modalComment').value,
                                                    lastUpdated: new Date().getTime()
                                                }, saveComment);
                                                this.props.clearField()
                                            }
                                        }}>Save</Button>
                                </Row>

                            </ButtonToolbar>
                        </Modal>)
                    }}
                </Mutation>
            </div >
        );
    }
}

function mapStateToProps (state) {
    return {
        user: state.auth.user
    }
}

export default connect(mapStateToProps, { addActivity, signout })(withRouter(withApollo(ModalComponent)));


// WEBPACK FOOTER //
// ./src/components/ComplianceModal.js